module.exports = __webpack_public_path__ + "media/images/massage/samia-8b49d01972b1d4660fd68f9959aa66e7.jpg";